import script from "./SheetsList.vue?vue&type=script&lang=ts&setup=true"
export * from "./SheetsList.vue?vue&type=script&lang=ts&setup=true"

import "./SheetsList.vue?vue&type=style&index=0&id=5f51e36e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f51e36e"]])

export default __exports__